var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16107_20888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1912 23.2179C24.5384 22.5734 23.7234 22.5734 23.0748 23.2179C22.58 23.7085 22.0852 24.1992 21.5987 24.6981C21.4656 24.8353 21.3534 24.8644 21.1912 24.773C20.871 24.5983 20.5301 24.457 20.2224 24.2657C18.7879 23.3634 17.5862 22.2033 16.5218 20.8977C15.9937 20.2491 15.5238 19.5547 15.1954 18.773C15.1288 18.615 15.1413 18.511 15.2702 18.3821C15.765 17.9039 16.2473 17.4133 16.7338 16.9226C17.4116 16.2407 17.4116 15.4424 16.7297 14.7563C16.343 14.3655 15.9563 13.9829 15.5696 13.5921C15.1704 13.1929 14.7754 12.7896 14.3721 12.3946C13.7193 11.7584 12.9043 11.7584 12.2556 12.3987C11.7567 12.8894 11.2785 13.3925 10.7712 13.8748C10.3014 14.3197 10.0644 14.8644 10.0145 15.5006C9.93548 16.536 10.1891 17.5131 10.5467 18.4653C11.2785 20.4362 12.3929 22.1867 13.7442 23.7917C15.5696 25.9621 17.7484 27.6794 20.2972 28.9185C21.4448 29.4757 22.634 29.9039 23.9272 29.9746C24.817 30.0245 25.5904 29.8 26.2099 29.1056C26.634 28.6316 27.1122 28.1992 27.5613 27.7459C28.2265 27.0723 28.2307 26.2574 27.5696 25.5921C26.7796 24.7979 25.9854 24.0079 25.1912 23.2179Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3969 19.9039L25.9312 19.6419C25.6901 18.2324 25.0248 16.9559 24.0144 15.9413C22.9458 14.8727 21.5944 14.1991 20.1059 13.9912L19.8896 15.5338C21.0414 15.696 22.0892 16.2157 22.9167 17.0432C23.6984 17.8249 24.2098 18.8145 24.3969 19.9039Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7965 13.2349C25.0251 11.4636 22.784 10.3451 20.31 10L20.0938 11.5426C22.231 11.842 24.1686 12.8108 25.6987 14.3368C27.1499 15.7879 28.1021 17.6216 28.4472 19.6383L29.9815 19.3763C29.5782 17.0395 28.4763 14.9189 26.7965 13.2349Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16107_20888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0eb6fe0ae3f8e347b11545d1007c071e.svg";
export { ForwardRef as ReactComponent };